import React from "react";
import styled from "styled-components";
import { Flex } from "../../../../../Flex";
import { Span } from "../../../../../Span";
import { Box } from "../../../../../Box";
import { DisconnectionDetails } from "../../../../../../types/DisconnectionDetails";
import {
  formatDateForDisplay,
  withNaCheck,
} from "../../../DisconnectionFormUtils/DisconnectionFormUtils";

interface Props {
  id: string;
  values: DisconnectionDetails;
}

const LabelWrapper = styled(Span)`
  color: ${({ theme }) => theme.colors.neutrals.dn40};
  min-width: 0;
  flex-basis: 0;
`;

const ValueWrapper = styled(Span)`
  min-width: 0;
  flex-basis: 0;
`;

const ValueCapitalizeWrapper = styled(Span)`
  min-width: 0;
  flex-basis: 0;
  text-transform: capitalize;
`;

export const ReviewFormDisconnectionDetails: React.FC<Props> = ({
  id,
  values,
}) => {
  return (
    <Box id={id}>
      <Flex flexDirection="row" mb={3}>
        <LabelWrapper lineHeight={2} flexGrow={[0.5, 0.5, 0.5, 0.4, 0.35]}>
          Reason for removal or disconnection
        </LabelWrapper>

        <ValueWrapper
          data-testid={`${id}-reason`}
          lineHeight={2}
          ml={3}
          flexGrow={[0.5, 0.5, 0.5, 0.6, 0.65]}
        >
          {values.removalReason}
        </ValueWrapper>
      </Flex>

      <Flex flexDirection="row" mb={3}>
        <LabelWrapper lineHeight={2} flexGrow={[0.5, 0.5, 0.5, 0.4, 0.35]}>
          Requested date of disconnection
        </LabelWrapper>

        <ValueWrapper
          data-testid={`${id}-date`}
          lineHeight={2}
          ml={3}
          flexGrow={[0.5, 0.5, 0.5, 0.6, 0.65]}
        >
          {formatDateForDisplay(values.disconnectionDate)}
        </ValueWrapper>
      </Flex>

      <Flex flexDirection="row" mb={3}>
        <LabelWrapper lineHeight={2} flexGrow={[0.5, 0.5, 0.5, 0.4, 0.35]}>
          Tenants in building
        </LabelWrapper>

        <ValueCapitalizeWrapper
          data-testid={`${id}-tenants`}
          lineHeight={2}
          ml={3}
          flexGrow={[0.5, 0.5, 0.5, 0.6, 0.65]}
        >
          {values.hasTenants}
        </ValueCapitalizeWrapper>
      </Flex>

      <Flex flexDirection="row" mb={3}>
        <LabelWrapper lineHeight={2} flexGrow={[0.5, 0.5, 0.5, 0.4, 0.35]}>
          Hazards to be aware of
        </LabelWrapper>

        <ValueWrapper
          data-testid={`${id}-hazards`}
          lineHeight={2}
          ml={3}
          flexGrow={[0.5, 0.5, 0.5, 0.6, 0.65]}
        >
          {withNaCheck(values.hazards)}
        </ValueWrapper>
      </Flex>

      <Flex flexDirection="row" mb={3}>
        <LabelWrapper lineHeight={2} flexGrow={[0.5, 0.5, 0.5, 0.4, 0.35]}>
          Any other information
        </LabelWrapper>

        <ValueWrapper
          data-testid={`${id}-information`}
          lineHeight={2}
          ml={3}
          flexGrow={[0.5, 0.5, 0.5, 0.6, 0.65]}
        >
          {withNaCheck(values.otherInformation)}
        </ValueWrapper>
      </Flex>
    </Box>
  );
};
